import { render, staticRenderFns } from "./SpecificationCostTable.vue?vue&type=template&id=55ad1ca5&scoped=true&"
import script from "./SpecificationCostTable.vue?vue&type=script&lang=js&"
export * from "./SpecificationCostTable.vue?vue&type=script&lang=js&"
import style0 from "./SpecificationCostTable.vue?vue&type=style&index=0&id=55ad1ca5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ad1ca5",
  null
  
)

export default component.exports